function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M4779.69 4779.69c492.85-492.85 739.28-1138.81 739.28-1784.74 0-645.92-246.44-1291.89-739.28-1784.74-492.85-492.85-1138.82-739.28-1784.75-739.28-645.93 0-1291.88 246.43-1784.73 739.28-492.85 492.85-739.29 1138.81-739.29 1784.74 0 645.92 246.44 1291.88 739.29 1784.74 492.85 492.85 1138.81 739.28 1784.74 739.28 645.92 0 1291.88-246.44 1784.74-739.28zm409.69 239.92l226.65 226.64 233.51 11.49 2479.25 2479.25-391.8 391.8-2479.25-2479.25-11.49-233.51-226.64-226.65c-570.94 527.5-1297.8 791.29-2024.66 791.29-764.12 0-1528.26-291.5-2111.24-874.49C300.73 4523.2 9.23 3759.06 9.23 2994.95c0-764.12 291.5-1528.26 874.48-2111.24C1466.69 300.73 2230.83 9.23 2994.94 9.23c764.11 0 1528.26 291.5 2111.24 874.48 582.98 582.98 874.48 1347.13 874.48 2111.24 0 726.86-263.78 1453.71-791.28 2024.66z",
  fill: "#2b2a29",
  fillRule: "nonzero",
  stroke: "#2b2a29",
  strokeWidth: 18.47,
  strokeMiterlimit: 22.926
});

function SvgLoupeThin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 8141.84 8141.84",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, props), _ref);
}

export default SvgLoupeThin;